import React from 'react'
import { Anchor, Container, Text } from './styles'

export const Disclaimer = (): JSX.Element => {
  return (
    <Container>
      <Text>
        Esta é uma ferramenta avaliada cientificamente (
        <Anchor href="https://pubmed.ncbi.nlm.nih.gov/36029889/" target="blank">
          https://pubmed.ncbi.nlm.nih.gov/36029889/
        </Anchor>
        ) desenvolvida para realizar predição a respeito de alterações de saúde que fazem parte da Síndrome Metabólica.
        Desta maneira, eventualmente poderá apoiar em sua orientação diagnóstica e na prevenção desta Síndrome. Na
        modelagem de dados, foram empregadas técnicas de anonimização, sem a possibilidade de identificação de dados
        pessoais, de acordo com os princípios de privacidade e segurança da informação regidos pelo Manual de Diretrizes
        de Conduta Ética da Sociedade Beneficente Israelita Brasileira Albert Einstein e pela Lei Geral de Proteção de
        Dados (Lei nº 13709/2018).
      </Text>
    </Container>
  )
}
